
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The breadcrumb informs the users on their current location relative to the
  homepage of the website and allows them to navigate to higher levels.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`The breadcrumb is an horizontal set of links`}{`*`}{` starting from the homepage or root of the hierarchy and work down to the current location.`}</p>
    <Paragraph size="s" mdxType="Paragraph">
  * except the last item in the group, which is the current page
    </Paragraph>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Breadcrumb/breadcrumb.png" alt="Anatomy of the breadcrumb" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item that redirects the user to the level in the hierarchy above the current page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Separator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Symbol that separates breadcrumb items it is also used to denote hierarchy, as in the format of Parent category `}{`>`}{` Child category`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Last item of the breadcrumb that indicates the current page.`}<br />{`It’s not a clickable element`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`the first element of the breadcrumb must always be labelled 'Home' and must link to the homepage of the actual site where the current user page is located`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`don't use long labels unless necessary`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`if your website's navigational structure is a tree of more than 2 levels`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`if your website's navigational structure has less than 3 levels of depth`}</li>
      <li parentName="ul">{`if your site navigational structure isn't a tree`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;